import { fromWei } from "web3-utils";

// @ts-ignore
const convertBigBigNumberToEther = (price) => {
  return Number(fromWei(String(price.toNumber()), "ether"));
};

export default convertBigBigNumberToEther;
